import EventsManagement from './EventsManagement';

export default EventsManagement;
